import LandingPage from './landing/LandingPage';
import SEO from '@/components/SEO';

const TITLE =
  'Discloser for Brokerages — The Deal Engine for California Teams';
const DESCRIPTION =
  'One disclosure standard for every agent, every packet, and every audit trail across your brokerage.';

const FAQ_LD = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  '@id': 'https://www.discloser.co/#faq-broker',
  mainEntity: [
    {
      '@type': 'Question',
      name: 'How does Discloser scale across a brokerage?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Every agent gets their own workspace; transaction coordinators get a deal-scoped view; managing brokers see oversight across the team. Discloser standardizes how disclosures are read and how findings are shared, so every deal in your brokerage has the same baseline of preparation.',
      },
    },
    {
      '@type': 'Question',
      name: 'Does Discloser replace our transaction coordinator?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'No. Discloser handles the AI-heavy work — reading the packet, drafting replies, ranking offers, citing the source page. Your TC handles the human coordination. The TC sees a Discloser view scoped to the deal so the handoff is clean.',
      },
    },
    {
      '@type': 'Question',
      name: 'How does brokerage pricing work?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '$19 per agent per month. 14-day free trial. Brokerage plans are available — contact sales@discloser.co for TC seats, oversight tooling, and per-agent rollout support.',
      },
    },
  ],
};

export default function LandingColorEfficiency() {
  return (
    <>
      <SEO title={TITLE} description={DESCRIPTION} path="/broker" jsonLd={FAQ_LD} />
      <LandingPage variant="efficiency" />
    </>
  );
}
